<template>
  <div>
    <div v-if="loaded" :key="forceReRenderKey" class="bg-darker border-radius container-fluid">
      <div class="row p-3">
        <div class="col-12">
          <h3>{{ $t('ProjectContent') }}</h3>
        </div>
        <div class="col-12 mb-2">
          <checkbox-widget
              :initial-value="showDetails"
              :label-text="$t('showDetails')"
              class="d-inline-block"
              label-for="showDetails"
              @change="(value) => showDetails = value"
          />
        </div>
        <div class="col-12 mb-2">
          <div v-if="instanceTypes.length === 0" class="instance-type-selector">
            {{ $t('NoInstancesInProject') }}
          </div>
          <div v-for="type in instanceTypes"
               :key="type"
               :class="['instance-type-selector clickable', selectedType === type ? 'selected' : '']"
               @click="selectedType = type">
            <div class="tag mb-2">{{ type }} ({{ instancesByType[type].length }})</div>
          </div>
          <div v-if="selectedType && instancesByType[selectedType] && instancesByType[selectedType].length"
               class="instance-list">
            <project-instance
                v-for="instance in instancesByType[selectedType]"
                :key="instance.id" :instance="instance"
                :show-details="showDetails"
                :project-teams="projectTeams"
                class="mb-1"
            />
          </div>
        </div>
      </div>
    </div>
    <loading-panel v-else/>
  </div>
</template>

<script>
import LoadingPanel from "./LoadingPanel";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";
import ProjectInstance from "./ProjectInstance.vue"

export default {
  name: "ProjectInstanceViewer",
  components: {CheckboxWidget, LoadingPanel, ProjectInstance},
  props: {
    itemId: {type: String, required: true},
    organizationId: {type: String, required: true},
    projectTeams: {type: Array, required: true},
  },
  data() {
    return {
      instances: [],
      instancesByType: {},
      loaded: false,
      forceReRenderKey: 0,
      showDetails: false,
      exportProfileField: '6139e14f-cc08-4dac-b2b6-527f9e9742ac',
      selectedType: 'assembly'
    };
  },
  computed: {
    instanceTypes() {
      return Object.keys(this.instancesByType).sort();
    }
  },
  beforeMount() {
    this.loadInstances();
  },
  methods: {
    loadInstances() {
      this.loaded = false;
      this.$store.dispatch('clientLoadProjectInstances', {
        id: this.itemId,
        include: ['metaValues', 'assetAndTeams'],
        fields: ['name', 'id', 'type', 'assetId']
      }).then(async instances => {
        this.instances = instances;
        for (let i = 0; i < instances.length; i++) {
          const {type} = instances[i];
          instances[i].hasExportProfile = this.hasExportProfile(instances[i]);
          if (!this.instancesByType[type]) {
            this.instancesByType[type] = [];
          }
          this.instancesByType[type].push(instances[i]);
        }
        this.loaded = true;
      })
    },
    hasExportProfile(instance) {
      const {metaValues} = instance;
      if (metaValues) {
        const referenceMetaField = metaValues.find(mv => {
          return mv.metaFieldId === this.exportProfileField;
        });
        if (referenceMetaField && referenceMetaField.value) {
          return true;
        }
      }
      return false;
    },
  }
}
</script>

<style lang="scss" scoped>
.bg-darker {
  background-color: rgba(0, 0, 0, 0.5);
}

.instance {
  padding: 5px 15px;
  background-color: var(--vform-editor-ui-secondary-color);
}

.instance-type-selector {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;

  &.selected {
    .tag {
      background-color: $highlight;
      color: white;
    }
  }
}

.instance-list {
  transition: all 300ms ease;
  min-height: 50vh;
}
</style>